import { render, staticRenderFns } from "./VtkFormItem.vue?vue&type=template&id=4a8a2588&scoped=true"
import script from "./VtkFormItem.vue?vue&type=script&lang=js"
export * from "./VtkFormItem.vue?vue&type=script&lang=js"
import style0 from "./VtkFormItem.vue?vue&type=style&index=0&id=4a8a2588&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8a2588",
  null
  
)

export default component.exports